import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";
import { auth } from "@/lib/firebase";
import { accountAccess } from "@/lib/accountAccess";
import { endDate, fmtDate, syncSubscriptionFromFirestore } from "@/lib/subscription";

export const SubscriptionBanner = () => {
  const { t, lang } = useI18n();
  const [sub, setSub] = useState(null);
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    let alive = true;
    syncSubscriptionFromFirestore(auth.currentUser?.uid).then((latest) => {
      if (alive) { setSub(latest); setNow(Date.now()); }
    }).catch(() => { if (alive) setSub(null); });
    return () => { alive = false; };
  }, []);
  const access = accountAccess(sub, now);
  const msLeft = sub?.trialEndsAt ? new Date(sub.trialEndsAt) - now : Infinity;
  useEffect(() => {
    if (access.accountType === "pilot" || access.status !== "trialing" || !Number.isFinite(msLeft) || msLeft <= 0) return undefined;
    const untilBoundary = msLeft > 2 * 86400000 ? msLeft - 2 * 86400000 : msLeft;
    const timer = setTimeout(() => setNow(Date.now()), Math.min(untilBoundary + 1, 2147483647));
    return () => clearTimeout(timer);
  }, [access.accountType, access.status, msLeft]);
  let text = null;
  let link = null;
  if (access.accountType !== "pilot" && access.status === "trialing" && msLeft <= 2 * 86400000 && msLeft > 0) {
    text = t("trial.h2", { date: fmtDate(lang, endDate(sub)) });
    link = t("banner.manage");
  } else if (sub && access.accountType !== "pilot" && (access.status === "past_due" || access.status === "expired")) {
    text = t("locked");
    link = null;
  }
  if (!text) return null;
  return (
    <div
      role="status"
      data-testid="subscription-banner"
      className="flex min-h-[44px] flex-wrap items-center gap-x-4 gap-y-1 border-b border-ax-border bg-ax-surface px-4 py-3 text-sm leading-5 text-ax-text md:px-6 lg:px-8"
    >
      <span className="min-w-0 flex-1 basis-[240px]">{text}</span>
      {link && (
        <Link to="/akun" data-testid="banner-link" className="font-medium text-ax-link hover:underline">
          {link}
        </Link>
      )}
    </div>
  );
};
